// extracted by mini-css-extract-plugin
module.exports = {"positionIndicator":"PositionIndicator_positionIndicator__3XOaj"};